import React, { Component } from 'react';
import { DownloadCard, Screen, SubHeader, Tabs, Text } from '../../../components';

import PropTypes from 'prop-types';
const { defaultStates, baseURL } = require('../../../utils/defaults');

import bannerMobile from '../../../assets/imgs/banner-standards-mobile.png';
import banner from '../../../assets/imgs/banner-standards.png';

import {
  standards,
  resolutions,
  circulars,
  circularLetter,
  legislation,
  policiesAndNorms,
  announcements,
} from '../../../enums';
import { StandardsContainer } from './styles';
import { Col, Row } from 'react-bootstrap';
import documentsService from '../../../services/documents';

class Standards extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...defaultStates(),
      innerWidth: window.innerWidth,
      documents: [],
      contents: [],
    };

    this.body = this.body.bind(this);
    this.header = this.header.bind(this);
    this.updateSize = this.updateSize.bind(this);
  }

  async componentDidMount() {
    const response = await documentsService.user.getList({});

    if (response.ok) {
      const newResponse = this.transformArray(response.data);
      this.setState(
        {
          documents: newResponse,
        },
        async () => {
          await this.tabsContent();
        },
      );
    }
  }

  transformArray = (data) => {
    return data.map((item) => ({
      title: item.name || 'Documento sem título',
      describe: item.describe,
      id: item.file_id_document,
      slug: item.file_document.slug,
      isActive: item.isActive,
      urlS3: item.file_document.urlS3,
    }));
  };

  updateSize = () => {
    this.setState({ innerWidth: window.innerWidth });
  };

  header = () => {
    return (
      <>
        <SubHeader
          image
          backgroundImage={banner}
          backgroundImageMobile={bannerMobile}
          minHeightSm={452}
          minHeight={313}
          title={'Conheça as normas'}
        />
      </>
    );
  };

  handleComponent = (data) => {
    const { documents } = this.state;

    const filteredDocuments = documents.filter((doc) => doc.describe === data && doc.isActive);

    const getHref = (doc) => {
      if (doc.urlS3.startsWith('https')) {
        return `${doc.urlS3}`;
      } else {
        return `${baseURL()}/api/file/${doc.id}/${doc.slug}`;
      }
    };

    return (
      <Col className={'mb-4 mb-lg-5 pb-3'}>
        {filteredDocuments.map((doc, index) => {
          return <DownloadCard documents key={index} title={doc.title} href={getHref(doc)} />;
        })}
      </Col>
    );
  };

  tabsContent = () => {
    this.setState({
      contents: [
        this.handleComponent('RESOLUCOES'),
        this.handleComponent('CIRCULARES'),
        this.handleComponent('CARTA_CIRCULARES'),
        this.handleComponent('LEGISLACAO'),
        this.handleComponent('POLITICA_E_NORMAS'),
        this.handleComponent('COMUNICADOS_DO_FGCOOP'),
      ],
    });
  };

  body = () => {
    const { documents } = this.state;

    const filteredDocuments = documents.filter((doc) => doc.describe === 'NORMAS' && doc.isActive);
    const getHref = (doc) => {
      if (doc.urlS3.startsWith('https')) {
        return `${doc.urlS3}`;
      } else {
        return `${baseURL()}/api/file/${doc.id}/${doc.slug}`;
      }
    };
    return (
      <StandardsContainer>
        <Row className={'mb-3 mb-lg-5 flex-column'}>
          <Col className={'d-flex justify-content-center mb-lg-3'}>
            <Text heading2 noWrap textAlign={'center'} title={{ one: 'NORMAS' }} />
          </Col>
          <Col>
            <Text
              paragraph3
              text={`O FGCoop tem sua atuação pautada no sistema legal vigente para garantir a segurança
              jurídica dos seus atos e a observância dos direitos de todos.<br><br> Para um regular
              funcionamento e visando as boas práticas de gestão, o FGCoop conta ainda com normas
              específicas, devidamente aprovadas pelos órgãos competentes.`}
            />
          </Col>
        </Row>
        <Row className={'mb-3 mb-lg-5'}>
          {filteredDocuments.map((doc, index) => {
            return (
              <Col key={index} lg={6} className={'mb-4 mb-lg-5 pb-3'}>
                <DownloadCard title={doc.title} href={getHref(doc)} />
              </Col>
            );
          })}
        </Row>

        <Row className={'mb-lg-4 pb-lg-2'}>
          <Col className={'d-flex flex-column align-items-center'}>
            <Text heading1 noWrap textAlign={'center'} title={{ one: 'DOCUMENTOS' }} />
          </Col>
        </Row>

        <Row className={'mb-lg-5 pb-lg-5'}>
          <Col style={{ marginBottom: '230px' }}>
            <Tabs
              labels={[
                'Resoluções',
                'Circulares',
                'Carta-circulares',
                'Legislação',
                'Políticas e normas',
                'Comunicados do FGCOOP',
              ]}
              contents={this.state.contents}
            />
          </Col>
        </Row>
      </StandardsContainer>
    );
  };

  render = () => {
    const { modalState, alertScreenState, loadingState } = this.state;

    return (
      <Screen
        header={this.header}
        body={this.body}
        modalState={modalState}
        alertScreenState={alertScreenState}
        loadingState={loadingState}
      />
    );
  };
}

Standards.propTypes = {
  //props
  history: PropTypes.object,
};
export default Standards;
